export default function SettingsDialogController(
  $q,
  $rootScope,
  $scope,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  controlDataService,
  controlSharedModelService,
  editControlTypeDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleSettingControlSubmit = _handleSettingControlSubmit;
  vm.handleExpandSettingsSection = _handleExpandSettingsSection;
  vm.handleShowAddControlTypeClick = _handleShowAddControlTypeClick;
  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
    vm.controlTypes.forEach((item) => {
      // item.type = 'pm-endnote';
      if (item.controlTypeId === 1) {
        vm.controlPreventiveEffectiveness = angular.copy(item);
      }
      if (item.controlTypeId === 2) {
        vm.controlDetectiveEffectiveness = angular.copy(item);
      }
      if (item.controlTypeId === 3) {
        vm.controlCorrectiveEffectiveness = angular.copy(item);
      }
      if (item.controlTypeId === 4) {
        vm.controlAdministrativeNature = angular.copy(item);
      }
      if (item.controlTypeId === 5) {
        vm.controlTechnicalNature = angular.copy(item);
      }
      if (item.controlTypeId === 6) {
        vm.controlPhysicalNature = angular.copy(item);
      }

      if (item.controlTypeId === 7) {
        vm.controlPrimaryControlType = angular.copy(item);
      }
      if (item.controlTypeId === 8) {
        vm.controlCompensatingControlType = angular.copy(item);
      }
    });
  }

  // Expand/Collapse
  function _handleExpandSettingsSection($event, section) {
    vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.settingControlDialog);
  }

  function _handleSettingControlSubmit() {
    if ($scope.settingControlForm.$valid) {
      loaderService.showViewLoader = true;
      const settings = {};
      settings.customerControlWeights = [];
      settings.customerControlWeights.push(vm.controlPreventiveEffectiveness);
      settings.customerControlWeights.push(vm.controlDetectiveEffectiveness);
      settings.customerControlWeights.push(vm.controlCorrectiveEffectiveness);
      settings.customerControlWeights.push(vm.controlAdministrativeNature);
      settings.customerControlWeights.push(vm.controlTechnicalNature);
      settings.customerControlWeights.push(vm.controlPhysicalNature);
      settings.customerControlWeights.push(vm.controlPrimaryControlType);
      settings.customerControlWeights.push(vm.controlCompensatingControlType);
      controlDataService.saveControlSettings(settings).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the control settings.');
        } else {
          alerts.success('The control setting has been saved successfully.');
          vm.saved = true;
          ssDialogService.hide(ssDialogService.dialogs.controlAdmin.settingControlDialog);
        }
        loaderService.showViewLoader = false;
      });
      // _saveControl();
    }
  }

  function _handleShowAddControlTypeClick($event) {
    const controlType = { customerControlTypeId: 0 };
    controlDataService.getControlTypeDefaults().then((response) => {
      controlType.controlPreventiveEffectiveness = response.data.controlPreventiveEffectiveness;
      controlType.controlDetectiveEffectiveness = response.data.controlDetectiveEffectiveness;
      controlType.controlCorrectiveEffectiveness = response.data.controlCorrectiveEffectiveness;
      controlType.controlAdministrativeNature = response.data.controlAdministrativeNature;
      controlType.controlTechnicalNature = response.data.controlTechnicalNature;
      controlType.controlPhysicalNature = response.data.controlPhysicalNature;
      controlType.controlPrimaryControlType = response.data.controlPrimaryControlType;
      controlType.controlCompensatingControlType = response.data.controlCompensatingControlType;
      controlType.controlReviewSchedule = response.data.controlReviewSchedule;
      ssDialogService.dialogs.controlAdmin.editControlTypeDialog = ssDialogService.alert(
        editControlTypeDialog.getOptions($event, {
          controlType,
          // controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlTypeDialog);
    });
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshControlTypes',
      _refreshControlTypes
    );
  }

  function _refreshControlTypes() {
    const dfdItem = $q.defer();
    controlDataService.getControlTypes().then((response) => {
      vm.controlTypeList = response.data.result;
      dfdItem.resolve();
    });

    return dfdItem.promise;
  }
}

SettingsDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'controlDataService',
  'controlSharedModelService',
  'editControlTypeDialog',
];
